var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17.75C14.4183 17.75 18 14.1683 18 9.75C18 5.33172 14.4183 1.75 10 1.75C5.58172 1.75 2 5.33172 2 9.75C2 14.1683 5.58172 17.75 10 17.75ZM10 7.12651C10.7604 7.12651 11.3768 6.51013 11.3768 5.74978C11.3768 4.98943 10.7604 4.37305 10 4.37305C9.23967 4.37305 8.62329 4.98943 8.62329 5.74978C8.62329 6.51013 9.23967 7.12651 10 7.12651ZM9.00562 8.99805V15.5972H11.0056V8.99805H9.00562Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b833b8cc706db2823bd6525252686dc4.svg";
export { ForwardRef as ReactComponent };